import { NextPage } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import MobileWebViewHeader from 'src/common/components/MobileWebViewHeader';
import { loadTranslations } from 'src/common/utils/serverSidePropsHelpers';
import Header from '../../src/common/components/Header';
import Layout from '../../src/common/components/Layout';
import DescriptionMetaTag from '../../src/common/components/MetaTags/DescriptionMetaTag';
import { AuthUserApiResponse } from '../../src/common/types/api/v4/auth/user';
import serverGetUser from '../../src/common/utils/serverGetUser';
import handleApiErrors from '../../src/common/utils/handleApiErrors';
import AcceptPanel from '../../src/content/Legal/AcceptPanel';
import PrivacyPolicy from '../../src/content/Legal/PrivacyPolicy';
import withCommonMiddleware from '../../src/common/utils/withCommonMiddleware';

type PrivacyPolicyPageProps = {
  user: Partial<AuthUserApiResponse>;
};

const PrivacyPolicyPage: NextPage = () => {
  const [t] = useTranslation('legal-privacy-policy');
  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <DescriptionMetaTag
        content={t('meta-description')}
      />
      <Layout>
        <MobileWebViewHeader />
        <Header />
        <PrivacyPolicy />
        <AcceptPanel />
      </Layout>
    </>
  );
};

export const getServerSideProps = handleApiErrors(
  withCommonMiddleware<PrivacyPolicyPageProps>(
    async (context) => ({
      props: {
        user: await serverGetUser(context),
        ...await loadTranslations(
          context.locale,
          [
            'common',
            'legal-privacy-policy',
            'navbar',
            'destination-navigation',
          ],
        ),
      },
    }),
  ),
);

export default PrivacyPolicyPage;
